import type { IgnoreModifier } from '@apollo/client/cache'

import { graphql, maskFragments } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'
import { client } from '~publish/legacy/apollo-client'

import { PostCardNotes_Note } from './fragments/PostCardNotes_Note'
import { UpdatedNoteOnPost } from './useAddNoteToPost'
import { useTypedMutation } from '../../hooks/useTypedMutation'

export const DeleteNoteFromPost = graphql(
  `
    mutation DeleteNoteFromPost($postId: PostId!, $noteId: NoteId!) {
      deleteNoteFromPost(input: { postId: $postId, noteId: $noteId }) {
        __typename
        ... on DeleteNoteFromPostSuccess {
          post {
            __typename
            id
            notes {
              ...PostCardNotes_Note
            }
          }
        }
        ... on MutationError {
          message
        }
      }
    }
  `,
  [PostCardNotes_Note],
)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useDeleteNoteFromPost = () =>
  useTypedMutation(DeleteNoteFromPost, (data) => data.deleteNoteFromPost, {
    successTypename: 'DeleteNoteFromPostSuccess',
    optimisticResponse: (
      { postId, noteId },
      { IGNORE },
    ):
      | {
          deleteNoteFromPost: {
            __typename: 'DeleteNoteFromPostSuccess'
            post: {
              __typename: 'Post'
              id: string
              notes: FragmentOf<typeof PostCardNotes_Note>[]
            }
          }
        }
      | IgnoreModifier => {
      const existingPost = client.readFragment({
        id: client.cache.identify({ __typename: 'Post', id: postId }),
        fragment: UpdatedNoteOnPost,
      })

      if (!existingPost) {
        return IGNORE
      }

      return {
        deleteNoteFromPost: {
          __typename: 'DeleteNoteFromPostSuccess',
          post: {
            id: postId,
            __typename: 'Post',
            notes: existingPost.notes
              .filter((note) => note.id !== noteId)
              .map((note) => maskFragments([PostCardNotes_Note], note)),
          },
        },
      }
    },
  })
